export default "__VITE_ASSET__B2G0wGxO__"